import { render } from "./SettingsOverview.vue?vue&type=template&id=14112076&ts=true"
import script from "./SettingsOverview.vue?vue&type=script&lang=ts"
export * from "./SettingsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__